//window.GlobalConfig = window.GlobalConfig ||

const globalConfig_default =
{
  appName: 'Nevron IPTV/OTT Solutions',
  url: 'http://api.dev.nevron.eu',
  path: '/api/middleware',
  showBetaFeatures: true,
  showOperators: true,
  wsAppKey: 'app-key',
  pusherHost: 'localhost',
  pusherPort: 6001
};

function globalConfig()
{
//Get defined config.
//
//Notice:
//In case loaded config fails to load set development environment.
//[W: in my eyes this is not proper behavior as not-loading config.js can be a severe issue, but history is history so I'll leave it].
  const config: any = ( window.GlobalConfig ) ? window.GlobalConfig : globalConfig_default;

  config.path = (config.path[0] === '/' ? config.path.slice(1) : config.path);

  return config;
}
export default globalConfig();
